import { render } from "./StoreView.vue?vue&type=template&id=2b13092c"
import script from "./StoreView.vue?vue&type=script&lang=js"
export * from "./StoreView.vue?vue&type=script&lang=js"

import "./StoreView.vue?vue&type=style&index=0&id=2b13092c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__